/* theme.js — Full Turn Nutrition */
/* Global JS: sticky header, mobile nav, cart count, Shopify section reload support */

(function () {
  'use strict';

  /* =============================================
     UTILITIES
     ============================================= */

  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  function trapFocus(element) {
    var focusableSelectors = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(', ');

    var focusableElements = Array.from(element.querySelectorAll(focusableSelectors));
    var firstFocusable = focusableElements[0];
    var lastFocusable = focusableElements[focusableElements.length - 1];

    function handleKeydown(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else {
        if (document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }

    element.addEventListener('keydown', handleKeydown);
    if (firstFocusable) firstFocusable.focus();

    return function () {
      element.removeEventListener('keydown', handleKeydown);
    };
  }

  /* =============================================
     STICKY HEADER
     ============================================= */

  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var lastScroll = 0;

    function onScroll() {
      var currentScroll = window.scrollY;
      if (currentScroll > 80) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      lastScroll = currentScroll;
    }

    window.removeEventListener('scroll', window._ftStickyScroll);
    window._ftStickyScroll = debounce(onScroll, 10);
    window.addEventListener('scroll', window._ftStickyScroll, { passive: true });
  }

  /* =============================================
     MOBILE NAV
     ============================================= */

  function initMobileNav() {
    var toggle = document.querySelector('.site-header__nav-toggle');
    var nav = document.querySelector('.site-header__nav-mobile');
    var closeBtn = document.querySelector('.site-header__nav-close');
    var overlay = document.querySelector('.site-header__nav-overlay');

    if (!toggle || !nav) return;

    var removeTrap = null;

    function openNav() {
      nav.setAttribute('aria-hidden', 'false');
      nav.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('nav-is-open');
      if (overlay) overlay.classList.add('is-visible');
      removeTrap = trapFocus(nav);
    }

    function closeNav() {
      nav.setAttribute('aria-hidden', 'true');
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('nav-is-open');
      if (overlay) overlay.classList.remove('is-visible');
      if (removeTrap) { removeTrap(); removeTrap = null; }
      toggle.focus();
    }

    toggle.removeEventListener('click', toggle._ftNavOpen);
    toggle._ftNavOpen = openNav;
    toggle.addEventListener('click', toggle._ftNavOpen);

    if (closeBtn) {
      closeBtn.removeEventListener('click', closeBtn._ftNavClose);
      closeBtn._ftNavClose = closeNav;
      closeBtn.addEventListener('click', closeBtn._ftNavClose);
    }

    if (overlay) {
      overlay.removeEventListener('click', overlay._ftNavClose);
      overlay._ftNavClose = closeNav;
      overlay.addEventListener('click', overlay._ftNavClose);
    }

    document.removeEventListener('keydown', document._ftNavEscape);
    document._ftNavEscape = function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        closeNav();
      }
    };
    document.addEventListener('keydown', document._ftNavEscape);
  }

  /* =============================================
     CART COUNT
     ============================================= */

  function updateCartCount() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEls = document.querySelectorAll('[data-cart-count]');
        var totalEls = document.querySelectorAll('[data-cart-total]');

        countEls.forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });

        totalEls.forEach(function (el) {
          var formatted = (cart.total_price / 100).toFixed(2);
          el.textContent = '$' + formatted;
        });
      })
      .catch(function (err) {
        console.warn('[Full Turn] Cart count update failed:', err);
      });
  }

  /* =============================================
     INIT
     ============================================= */

  function init() {
    initStickyHeader();
    initMobileNav();
    updateCartCount();
  }

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('shopify:section:load', function (e) {
    init();
  });

})();
